<template>
  <Modal ref="instrutorModal" :title="title" @cancel="closeInstrutorModal">
    <div class="photo-container">
      <div class="section">
        <span>Câmera</span>

        <video class="video" ref="video" width="500" height="375" autoplay playsinline></video>

        <Button class="center-button" @handle:click="capturePhoto" text="Capturar" color="primary"
          :disabled="sendLoading">
          <CameraOutline :size="18" />
        </Button>
      </div>

      <div class="section">
        <span>Foto da presença</span>

        <div v-if="!photoCaptured" class="empty-photo">
          <CameraOutline :size="160" />
        </div>

        <canvas v-show="photoCaptured" class="video" ref="canvas" width="500" height="375"></canvas>

        <Button @handle:click="sendPhoto" class="center-button" text="Enviar" color="primary"
          :disabled="!photoCaptured || sendLoading">
          <SendVariantOutline :size="18" />
        </Button>
      </div>
    </div>
  </Modal>
</template>

<script>
import Modal from 'core/Modal'
import Button from 'core/Button'
import CameraOutline from 'icons/CameraOutline'
import SendVariantOutline from 'icons/SendVariantOutline'

export default {
  name: 'PhotoModal',
  components: {
    Modal,
    Button,

    CameraOutline,
    SendVariantOutline,
  },
  props: {

  },
  data() {
    return {
      title: '',
      data: null,
      stream: null,
      photoCaptured: false,
      sendLoading: false,
    }
  },
  beforeDestroy() {
    if (this.stream) {
      this.stream.getTracks().forEach(track => track.stop())
    }
  },
  methods: {
    async open(title, data) {
      this.title = title
      this.data = data

      try {
        this.stream = await navigator.mediaDevices.getUserMedia({ video: true })

        this.$refs.video.srcObject = this.stream
        this.$refs.instrutorModal.open()
      } catch (err) {
        if (err.name === 'NotAllowedError') {
          this.$toasted.show(
            `Acesso à câmera negado! Permita o acesso antes de continuar com o registro de presença.`,
            {
              position: 'top-right',
            }
          )
        } else if (err.name === 'NotFoundError' || err.name === 'DevicesNotFoundError') {
          this.$toasted.show(
            `Nenhuma câmera encontrada! Conecte um dispositivo de vídeo antes de continuar.`,
            {
              position: 'top-right',
            }
          )
        } else if (err.name === 'NotReadableError' || err.name === 'TrackStartError') {
          this.$toasted.show(
            `Erro ao acessar a câmera! Outro aplicativo pode estar usando o dispositivo.`,
            {
              position: 'top-right',
            }
          )
        } else {
          this.$toasted.show(`Erro ao acessar a câmera: ${err.message}`, {
            position: 'top-right',
          })
        }
      }
    },
    capturePhoto() {
      if (!this.stream) return

      const video = this.$refs.video
      const canvas = this.$refs.canvas
      const context = canvas.getContext("2d")

      context.drawImage(video, 0, 0, 500, 375)

      this.photoCaptured = true
    },
    async sendPhoto() {
      if (!this.data.cpf) {
        this.$toasted.show(`Dados insuficientes.`, {
          position: 'top-right',
        })

        return
      }

      const canvas = this.$refs.canvas

      if (!canvas || !this.photoCaptured) {
        this.$toasted.show(`Capture uma foto antes do envio.`, {
          position: 'top-right',
        })

        return
      }

      this.sendLoading = true

      const photoDataUrl = canvas.toDataURL()

      const data = {
        foto: photoDataUrl,
        cpf: this.data.cpf,
        virtual: false,
      }

      await this.$http.post(`${process.env.VUE_APP_URL_API}/presencas/reconhecimento`, data)
        .then(async res => {
          if (this.data.typeSend === 'instrutor') {
            await this.registerInstructor(res.body.dados)
          } else if (this.data.typeSend === 'aluno') {
            await this.registerStudent(res.body.dados)
          }

          this.closeInstrutorModal()
        })
        .catch(err => {
          this.$toasted.show(`Erro ao enviar foto.`, {
            position: 'top-right',
          })

          this.$toasted.show(err.body.mensagem, {
            position: 'top-right',
          })
        })
        .finally(() => {
          this.sendLoading = false
        })
    },
    async registerInstructor(path) {
      const data = {
        cpfInstrutor: this.data.cpf,
        turma: this.data.idTurmaTeorica,
        pathImg: path,
      }

      await this.$http.post(`${process.env.VUE_APP_URL_API}/instrutores/registrar/presenca`, data)
        .then(res => {
          this.$toasted.show('Presença registrada!', {
            position: 'top-right',
          })
        })
        .catch(err => {
          this.$toasted.show(err.body.mensagem, {
            position: 'top-right',
          })
        })
    },
    async registerStudent(path) {
      const data = {
        cpfAluno: this.data.cpf,
        turma: this.data.idTurmaTeorica,
        pathImg: path,
        tipo: this.data.type,
      }

      await this.$http.post(`${process.env.VUE_APP_URL_API}/alunos/registrar/presenca`, data)
        .then(res => {
          this.$toasted.show('Presença registrada!', {
            position: 'top-right',
          })
        })
        .catch(err => {
          this.$toasted.show(err.body.mensagem, {
            position: 'top-right',
          })
        })
    },
    closeInstrutorModal() {
      if (this.stream) {
        this.stream.getTracks().forEach(track => track.stop())
        this.stream = null
      }

      this.photoCaptured = false

      this.$refs.instrutorModal.close()
    },
  }
}
</script>

<style lang="scss" scoped>
.photo-container {
  display: flex;
  gap: 1rem;

  .section {
    flex: 1;

    display: flex;
    flex-direction: column;
    gap: 0.5rem;

    span {
      font-size: 1.25rem;
      font-weight: 600;
    }

    .empty-photo {
      box-sizing: border-box;
      width: 500px;
      height: 375px;

      display: flex;
      justify-content: center;
      align-items: center;
    }

    .video {
      width: 500;
      height: 375;
      border-radius: 6px;
    }

    .center-button {
      justify-content: center;
    }
  }
}
</style>